module.exports = __webpack_public_path__ + "img/paste-white.f5e0fefb.svg";